import React, { useEffect, useRef, useState } from "react";
import { List, Button, Spin, Result, message, Radio } from "antd";
import useQuery from "../../../hooks/useQuery";
import { formatTimestamp } from "../../../utils/format";
import PageTabs from "../../../components/PageTabs";
import styles from "./index.module.scss";
import request from "../../../network/request";
import { IConfigItem, IConfigRes } from "../../../network/models/ConfigType";
import { IHistoryItem, IHistoryRes } from "../../../network/models/HistoryType";
import ReviseFrame from "./components/ReviseFrame";
import notAllowMove from "./../../../utils/scroll-lock";

export default function HistoryPage() {
  const useQueryIns = useQuery();
  const tid = useQueryIns.get("tid");
  const pageSize = 10;
  const pageIndexRef = useRef(1);
  const pageContentRef = React.useRef(null);

  const [initLoading, setInitLoading] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<boolean>(false);
  const [show, setShow] = useState<boolean>(false);
  const [recordData, setRecordData] = useState<IHistoryItem[]>([]);
  const [total, setTotal] = useState<number>(0);
  const problemStatusRef = React.useRef('no');
  const [currentServiceItem, setCurrentServiceItem] = useState<IHistoryItem>({
    className: "",
    tagName: "",
    typeLabel: "",
    id: 0,
    tid: "",
    startTime: 0,
    finishTime: 0,
    problemSolved: "",
    problemSolvedNewest: "",
  });

  useEffect(() => {
    setInitLoading(true);
    getInitialData();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const getInitialData = async () => {
    getRecordData();
  };

  const getRecordData = async () => {
    try {
      const problemStatus =problemStatusRef.current
      const { total, records }: IHistoryRes = await request.get(
        "/dragon/service/record/listPage",
        {
          params: {
            tid,
            pageIndex: pageIndexRef.current,
            pageSize,
            problemStatus,
          },
        }
      );
      // 对不同情况下不同展示时，添加快捷的classname和tagName
      if (records.length > 0) {
        records.forEach((item) => {
          let tempObj: any = item;
          if (tempObj.problemSolvedNewest !== "") {
            tempObj.className = styles.disableChange;
            if (tempObj.problemSolvedNewest === "no") {
              tempObj.tagName = "未解决";
            }
            if (tempObj.problemSolvedNewest === "yes") {
              tempObj.tagName = "已解决";
            }
            if (tempObj.problemSolvedNewest === "unknown") {
              tempObj.tagName = "未知";
            }
          } else {
            if (tempObj.problemSolved === "no") {
              tempObj.className = styles.redCanChange;
              tempObj.tagName = "未解决";
            } else {
              if (tempObj.problemSolved === "yes") {
                tempObj.tagName = "已解决";
              }
              if (tempObj.problemSolved === "unknown") {
                tempObj.tagName = "未知";
              }
              tempObj.className = styles.canChange;
            }
          }
        });
      }
      console.log(records, "1111111");
      setTotal(total);
      if (pageIndexRef.current === 1) {
        console.log(pageIndexRef.current);
        setRecordData(records);
      } else {
        console.log(pageIndexRef.current);
        setRecordData([...recordData, ...records]);
      }
    } catch (err) {
      console.log(err);

      setError(true);
    } finally {
      setInitLoading(false);
      setLoading(false);
    }
  };

  const getTypeLabel = (item) => {
    const typeLabel = JSON.parse(item.typeLabel);
    const typeList = typeLabel.map((item1, index) => {
      return (
        <h3 className={styles.recordItemTitle} key={index}>
          {item1}
        </h3>
      );
    });
    return <>{typeList}</>;
  };

  const onLoadMore = () => {
    pageIndexRef.current += 1;
    setLoading(true);
    getRecordData();
  };
  const handleProStaChange = (e) => {
    console.log(e.target.value, 12312312);
    // setProblemStatus(e.target.value);
    problemStatusRef.current = e.target.value;
    pageIndexRef.current = 1
    getRecordData();
  };

  const handleReload = async () => {
    setInitLoading(true);
    setError(false);
    getRecordData();
  };

  const changeState = (item) => {
    if (item.problemSolvedNewest !== "") {
      //已经修改过，return
      return;
    }
    notAllowMove.enable();
    setCurrentServiceItem(item);
    setShow(true);
  };

  const handleCancel = () => {
    console.log("取消");
    notAllowMove.disable();
    setShow(false);
  };
  const handleSuccess = async (result) => {
    console.log(result);
    notAllowMove.disable();
    try {
      await request.post("/dragon/service/updateProblemSolvedNewest", {
        id: currentServiceItem.id,
        tid: currentServiceItem.tid,
        problemSolvedNewest: result === "已解决" ? "yes" : "no",
      });
      recordData?.forEach((item, index) => {
        if (
          currentServiceItem !== undefined &&
          item.id === currentServiceItem.id
        ) {
          console.log(index, "对应的index");
          recordData[index].tagName = result;
          recordData[index].problemSolvedNewest = result;
          recordData[index].className = styles.disableChange;
        }
      });
      setShow(false);
      setRecordData(recordData);
    } catch (err) {
      setShow(false);
      console.log(err);
    }
  };

  const loadMore =
    !initLoading && !loading && pageIndexRef.current * pageSize < total ? (
      <div className={styles.loadMoreContainer}>
        <Button onClick={onLoadMore}>加载更多</Button>
      </div>
    ) : null;

  return (
    <>
      <div className={styles.pageWraps} ref={pageContentRef}>
        <PageTabs></PageTabs>
        <div className={styles.pageContent}>
          {error ? (
            <Result
              subTitle="数据加载失败，请稍后重试"
              extra={
                <Button type="primary" onClick={handleReload}>
                  重新加载
                </Button>
              }
            />
          ) : (
            <>
            <div className={styles.problemStatus}>
              <Radio.Group
                value={problemStatusRef.current}
                onChange={handleProStaChange}
                buttonStyle='solid'
                size='middle'
              >
                <Radio.Button value="">所有</Radio.Button>
                <Radio.Button value="no">未解决</Radio.Button>
                <Radio.Button value="yes">已解决</Radio.Button>
                <Radio.Button value="unknown">未知</Radio.Button>
              </Radio.Group>
              </div>
              <List
                loading={initLoading}
                itemLayout="vertical"
                dataSource={recordData}
                loadMore={loadMore}
                renderItem={(item: any) => (
                  <List.Item>
                    <div className={styles.title}>
                      <div>
                        <p className={styles.recordItemTime}>
                          开始时间：{formatTimestamp(item?.startTime)}
                        </p>
                        <p className={styles.recordItemTime}>
                          结束时间：{formatTimestamp(item?.finishTime)}
                        </p>
                      </div>
                      <div
                        className={item.className}
                        onClick={() => {
                          changeState(item);
                        }}
                      >
                        <div>{item.tagName}</div>
                        <div className={styles.changeIcon}></div>
                      </div>
                    </div>
                    {item.typeLabel && getTypeLabel(item)}
                  </List.Item>
                )}
              />
              {loading && (
                <div className={styles.loadMoreContainer}>
                  <Spin></Spin>
                </div>
              )}
            </>
          )}
        </div>
      </div>
      {show && (
        <ReviseFrame
          currentItem={currentServiceItem}
          onCancel={handleCancel}
          onSuccess={handleSuccess}
        />
      )}
    </>
  );
}
